var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 259,
    height: 299,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M259 149.511L.108 298.5l69.925-148.989L0 .5l259 149.011z",
    fill: "#0061E5"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNTkiIGhlaWdodD0iMjk5IiB2aWV3Qm94PSIwIDAgMjU5IDI5OSIgZmlsbD0ibm9uZSI+CiAgICA8cGF0aCBvcGFjaXR5PSIwLjEiIGQ9Ik0yNTkgMTQ5LjUxMUwwLjEwNzgwNiAyOTguNUw3MC4wMzI2IDE0OS41MTFMMCAwLjQ5OTk4OUwyNTkgMTQ5LjUxMVoiIGZpbGw9IiMwMDYxRTUiLz4KPC9zdmc+Cg==";
export { SvgArrow as ReactComponent };